export const styles = theme => ({
    container: {
        padding: "5px",
        justifyContent: "center",
        alignContent: "center",
        backgroundColor: "transparent",
        borderColor: "transparent"
    },
    headerText: {
        alignSelf: "center",
        marginRight: "5px",
        textAlign: "center"
    },
    starsContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignContent: "center"
    }
})